import React from 'react';
import dayjs from 'dayjs';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

export const DateTimeTypeProvider = (props) => {
  return (
    <DataTypeProvider
      formatterComponent={({ value }) => {
        const offset = value.slice(-6);
        const datetime = value.substring(0, 19);

        return dayjs(datetime + offset).format('MM/DD/YYYY HH:mm z');
      }}
      {...props}
    />
  );
};
